<script>
import Tabs from '@/components/Tabs';
import General from './General';
import ChangePassword from './ChangePassword';

export default {
  name: 'ModuleAccount',
  components: {
    Tabs,
  },
  computed: {
    tabs () {
      return [
        {
          id: 'general',
          label: 'General',
          component: General,
          active: true,
        },
        {
          id: 'changePassword',
          label: 'Change Password',
          component: ChangePassword,
        },
      ];
    },
  },
};
</script>
<template>
  <div class="box">
    <Tabs :tabs="tabs" />
  </div>
</template>
